/* global Auth, TrelloPowerUp */

const kApiEndpoint = require('./api-endpoint.js');

const handleBitbucketIntegration = (verb, context) => {
  switch (verb) {
    case 'describe':
      return handleBitbucketDescribe(context);
    case 'connect':
      return handleBitbucketConnect(context);
    case 'revoke':
      return handleBitbucketDisconnect(context);
    default:
      console.error(`Unknown verb: ${verb}`);
      return '';
  }
};

const handleBitbucketDescribe = context => {
  return `Connected Account: \`${context.params
    .map(appData => {
      return `${Object.values(appData)
        .map(account => account.connection_name)
        .join(', ')}`;
    })
    .join(', ')}\``;
};

const registerApps = registerApp => {
  registerApp('Bitbucket', handleBitbucketIntegration);
};

const handleBitbucketConnect = context => {
  const { t } = context;
  let digest;
  return Auth.getToken(t)
    .then(token => {
      if (!token) throw new Error('Bitbucket OAUTH: NO TRELLO TOKEN');
      const { crypto } = TrelloPowerUp.util;
      const iv = [];
      crypto.generateInitVector().forEach(b => iv.push(`0${b.toString(16)}`.substr(-2)));
      return crypto.sha256Digest(`${iv.join('')}:${t.getContext().member}:${token}`);
    })
    .then(_digest => {
      digest = _digest;
      const clientId = 'qTaYTtxwPXWFn4jeLv';
      const authHost = 'https://bitbucket.org';

      console.log('clientId', clientId);
      const authUrl = `${authHost}/site/oauth2/authorize?client_id=${clientId}&response_type=code&state=${digest}`;
      return t.authorize(authUrl, {});
    })
    .then(token => {
      const [code, status] = token.split(':');
      if (status !== digest) {
        throw new Error('Bitbucket OAUTH: STATUS MISMATCH');
      }
      return context.submitIntegrationConnectRequest({ code });
    });
};

const handleBitbucketDisconnect = context => {
  const { t, params } = context;

  console.log(params, 'params');
  const action = $(params.event.target).siblings(
    '.integration-description[data-app-name="Bitbucket"]'
  );

  if (action.length && action.find('code')) {
    const accountName = action.find('code').text();
    return Auth.getToken(t).then(token => {
      if (!token) throw new Error('BITBUCKET DISCONNECT: NO TRELLO TOKEN');
      return new Promise((resolve, reject) => {
        $.ajax(`${kApiEndpoint}integration-disconnect`, {
          type: 'POST',
          headers: { 'X-Butler-Trello-Token': Auth.getActiveToken() },
          data: JSON.stringify({
            appName: 'Bitbucket',
            resourceName: accountName,
          }),
          contentType: 'application/json',
        })
          .done(function(response) {
            if (response.success) {
              return resolve();
            }
            return reject(new Error(response.error || 'Unknown error'));
          })
          .fail(function(error) {
            return reject(error);
          });
      });
    });
  }

  return '';
};

const oauthCallback = () => {
  const code = (window.location.search.match(/[?&]code=([-_a-zA-Z0-9]*)/) || [])[1];
  const state = (window.location.search.match(/[?&]state=([a-fA-F0-9]*)/) || [])[1];
  // TODO: ensure status matches error, requesting, success.
  if (!code) {
    showStatus('error');
    return;
  }

  showStatus('requesting');

  const token = `${code}:${state}`;

  try {
    window.opener.authorize(token);
  } catch (e) {
    try {
      localStorage.setItem('token', token);
    } catch (e) {
      showStatus('error');
      throw new Error('Bitbucket OAUTH: CANNOT RETURN CODE');
    }
  }

  showStatus('success');
  setTimeout(window.close, 1000);
};

const showStatus = status => {
  $('.oauth-bitbucket-status').addClass('hidden');
  $(`.oauth-bitbucket-status.status-${status}`).removeClass('hidden');
};

module.exports = {
  registerApps,
};

window.BitbucketOAuthCallback = oauthCallback;
